<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item>待办事项</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="24">
      <el-col :span="12">
        <div class="grid-content bg-white" @click="jumpHandler(0)">
          <i class="el-icon-document icon"></i>
          <span class="text-wrapper">
            <span class="text">待审核订单</span>
            <span class="num">{{user.toDoList.confirmOrderNum}}</span>
          </span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content bg-white" @click="jumpHandler(1)">
          <i class="el-icon-truck icon"></i>
          <span class="text-wrapper">
            <span class="text">待发货课程</span>
            <span class="num">{{user.toDoList.shipmentOrderNum}}</span>
          </span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content bg-white" @click="jumpHandler(2)">
          <i class="el-icon-printer icon"></i>
          <span class="text-wrapper">
            <span class="text">待打印实卡</span>
            <span class="num">{{user.toDoList.printCardNum}}</span>
          </span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content bg-white" @click="jumpHandler(3)">
          <i class="el-icon-takeaway-box icon"></i>
          <span class="text-wrapper">
            <span class="text">待发货实卡</span>
            <span class="num">{{user.toDoList.shipmentCardNum}}</span>
          </span>
        </div>
      </el-col>
    </el-row>
  </div>

</template>

<script type="text/ecmascript-6">
  import {mapGetters} from 'vuex';

  export default {
    name: 'index',
    methods: {
      jumpHandler(index) {
        switch (index) {
          case 0:
            this.$router.push({ path: '/order_list/1', query: { status: 2 }});
            break;
          case 1:
            this.$router.push({ path: '/order_list/1', query: { status: 4 }});
            break;
          case 2:
            break;
          case 3:
            break;
        }
      },
    },
    computed: {
      ...mapGetters([
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    .title
      margin-bottom: 20px;
    .bg-white
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;
      padding: 20px 0;
      border-radius: 5px;
      cursor: pointer;
      background: #fff;
      .icon
        display: inline-block;
        margin-right: 20px;
        font-size: 40px;
        color: #409EFF;
      .text-wrapper
        display: inline-block;
        .text
          display: block;
          margin-bottom: 10px;
          color: #666;
        .num
          display: block;
          color: #67C23A;
</style>